module.exports = __webpack_public_path__ + "img/2.c9005b49.svg";